<template>
  <div>
    <breadcrumbs></breadcrumbs>
    <div class="datd-abc">
      <div class="ind-title lh50 f16">
        <!-- <i class="el-icon-loading"></i> -->
        库存详情
      </div>
    </div>

    <!-- <div class="con-let"></div> -->

    <div v-if="infolist.state == 1">审核通过</div>

    <div v-if="infolist.state == 2">审核失败</div>

    <div class="con-let"></div>
    <el-table
      :data="tableData"
      style="width:100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <el-table-column label="序号" prop="index" type="index">
      </el-table-column>

      <el-table-column label="品牌" prop="brandName"> </el-table-column>

      <el-table-column label="原次品总数" prop="oldDefCount"> </el-table-column>

      <el-table-column label="变更次品总数为" prop="realDefCount">
      </el-table-column>

      <el-table-column label="当前库存数" prop="oldStockCount">
      </el-table-column>

      <el-table-column label="变更当前库存数" prop="realStockCount">
      </el-table-column>
    </el-table>

    <div class="con-let"></div>

    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="变更原因">
        <el-input
          type="textarea"
          style="width:40%"
          v-model="infolist.remark"
        ></el-input>
      </el-form-item>
    </el-form>

    <div class="t2" v-if="infolist.state == 0">
      <el-button type="primary" @click="getchue">审核</el-button>
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      infolist: "",

      info: "",
      tableData: [],
      shanghai: "",
      beijing: "",
      searchForm: {
        name: "",
        region: "",
      },
    };
  },

  created() {
    this.getCheckInfo();
  },

  methods: {
    getchue() {
      this.$api.activitymsg
        .checkyhx({
          checkId: this.$route.query.oid,
          state: 1,
          reson: this.infolist.remark,
        })
        .then((e) => {
          if (e.code == 200) {
            this.$message({
              message: "审核成功",
              type: "success",
            });

            this.$router.push("/index/add");
          } else {
            this.$message.error(e.msg);
          }
        });
    },

    getCheckInfo() {
      this.$api.activitymsg
        .getCheckInfo({
          checkId: this.$route.query.oid,
        })
        .then((e) => {
          this.infolist = e.data.info;

          this.tableData = e.data.list;
        });
    },
  },
};
</script>

<style scoped>
.t2 {
  width: 90%;
  margin: auto;
}

.con-let {
  height: 50px;
}

.a7 {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.a4 {
  margin-left: 20px;
}

.a3 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;

  color: var(--text-main);
  opacity: 1;
}

.a2 {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: var(--text-main);
  opacity: 1;
}

.a1-img {
  width: 100px;
  height: 100px;
}
.a1 {
  width: 260px;
  height: 127px;
  opacity: 1;
  border-radius: 10px;
  border: solid 1px var(--table-border);
  display: flex;
  align-items: center;
  padding: 0 20px;
}
</style>
